import { render } from "./PaymentDetails.vue?vue&type=template&id=6f8230ad"
import script from "./PaymentDetails.vue?vue&type=script&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&lang=js"

import "./PaymentDetails.vue?vue&type=style&index=0&id=6f8230ad&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__